import {FuseRouteItemType} from '@/@fuse/utils/FuseUtils';
import {AUTH_ROLES} from '@/app/auth/authRoles';
import LinkExpiredPage from '@/app/main/authentication/pages/LinkExpired/LinkExpiredPage';

const LinkExpiredRoute: FuseRouteItemType = {
  path: 'password/link-expired',
  element: <LinkExpiredPage />,
  auth: AUTH_ROLES.onlyGuest,
};

export default LinkExpiredRoute;
